<template>
  <div :class="$style['header']">
    <button
      v-if="!isDeliveryMan"
      :class="$style['link']"
      @click="displayPanel()"
    >
      <span
        v-if="newNotifications"
        :class="$style['pastille']"
      />
      <IconBell
        :size="20"
        :fill="'var(--color-primary-700)'"
      />
    </button>
    <div :class="$style['name']">
      <LogoInterfloraText :class="$style['name--logo']" />
      <Paragraph3 :class="$style['name--label']">{{ floristInfo.shopLocation.name }}</Paragraph3>
    </div>
    <!-- <NuxtLink
      :to="{ name: RouteNames.MyPage }"
      :class="$style['link']"
    >
      <IconProfile
        :size="20"
        :fill="'var(--color-primary-700)'"
      />
    </NuxtLink>
    <a
      v-if="keycloak"
      target="_blank"
      :class="$style['label']"
      @click="logoutEvent"
    >
      <Paragraph3>{{ $t('nav.signOut') }}</Paragraph3>
    </a> -->
    <div :class="$style['link-container']">
      <button
        v-if="ONBOARDING_GUIDES"
        :class="$style['link']"
        @click="showGuide('recipientConfirmation', 'manual')"
      >
        <UIcon
          name="material-symbols-light:developer-guide-outline"
          :class="$style['link--icon']"
        />
      </button>
      <Dropdown
        :label="''"
        :icon="'IconProfile'"
        :class="$style['link']"
        :is-mobile-nav="true"
      >
        <NuxtLink
          v-if="isManager"
          :to="{ name: RouteNames.Admin }"
          :class="$style['link--item']"
        >
          <Paragraph4>{{ $t('nav.admin') }}</Paragraph4>
        </NuxtLink>
        <NuxtLink
          v-if="floristInfo"
          to="/"
          event=""
          :class="$style['link--item']"
          @click="logoutEvent"
        >
          <Paragraph4>{{ $t('nav.signOut') }}</Paragraph4>
        </NuxtLink>
      </Dropdown>
    </div>
  </div>
  <NavigationMobileNav
    v-if="!isDeliveryMan"
    :nav="nav"
  />
</template>

<script lang="ts" setup>
import { IconBell } from '~/components-daisy/icons';
import { notificationParams } from '~/app/types/notificationType';
import { Paragraph3, Paragraph4 } from '~/components-daisy/typography';
import { RouteNames } from '~/app/routes/routeNames';
import LogoInterfloraText from '~/components-daisy/logos/interflora/LogoInterfloraText.vue';
import Dropdown from '~/components/Dropdown.vue';
import useOnboarding from '~/composables/onboarding/useOnboarding';

const store = useFloristInfoStore();
const floristInfoStore = useFloristInfoStore();
const floristInfo = ref(floristInfoStore.floristInfo);
const isManager = ref(floristInfoStore.floristInfo.users[0].role === 'SHOP_OWNER' ? true : false);
const isDeliveryMan = ref(store.isDeliveryMan);

type Props = {
  newNotifications: boolean;
  nav: any[];
};

defineProps<Props>();

const emits = defineEmits(['notification']);

const displayPanel = () => {
  notificationParams.displayedPanel = !notificationParams.displayedPanel;
  return emits('notification', notificationParams.displayedPanel);
};

const logoutEvent = () => {
  const config = useRuntimeConfig();
  store.clearFloristInfo();
  logout(config.public.logoutUrl);
};

const { ONBOARDING_GUIDES } = await useCountryParams();
const { showGuide } = useOnboarding();
</script>

<style lang="postcss" module>
.header {
  @media (min-width: 900px) {
    display: none;
  }

  @media (max-width: 900px) {
    position: relative;
    padding: var(--space-100);
    background-color: var(--color-mono-300);
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    box-shadow: var(--shadow-200);
  }
}
.link {
  display: flex;
  align-items: center;
  gap: var(--space-100);
  cursor: pointer;
  background-color: transparent;
  flex-direction: column;
  width: 42px;
  height: 42px;
  border: none;
  cursor: pointer;
  justify-content: center;
  padding: var(--space-50) var(--space-100);
  grid-column: 1;
  justify-self: start;

  &:last-child {
    grid-column: 3;
    justify-self: end;
  }

  &--item {
    height: 42px;
    width: 42;
    display: flex;
    align-items: center;
    z-index: 50;
    cursor: pointer;
    padding: var(--space-50) var(--space-150);

    &:hover {
      border-radius: var(--border-radius-100);
      background-color: var(--color-primary-200);
      color: var(--color-primary-700);
    }
  }
  &:hover {
    background-color: var(--color-primary-200);
    border-radius: var(--border-radius-100);
    color: var(--color-primary-700);
  }

  &--icon {
    color: var(--color-primary-700);
    width: 24px;
    height: 24px;
  }
}

.link-container {
  display: flex;
  gap: var(--space-50);
  justify-content: end;
  margin-inline: 20px;
}

.name {
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-column: 2;
  justify-self: center;
  &--logo {
    height: 25px;
  }
  &--label {
    color: var(--color-primary-800);
    text-align: center;
  }
}

.label {
  color: var(--color-primary-800);
  height: 42px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pastille {
  background-color: var(--color-primary-700);
  border-radius: var(--border-radius-600);
  box-shadow: var(--shadow-200);
  margin-right: -15px;
  margin-top: 15px;
  padding: 5px;
  position: absolute;
}
</style>
